import { defineStore } from 'pinia';

export const useUser = defineStore('user', {
    state: () => ({ 
        profile: {
            name: '',
            lang: '',
            id: null,
            email: '',
        },
        build_timestamp: null,
        debug: true,
        auth: {
            token: '',
        },
    }),
});